import logo from "../../assets/images/mim-logo.png";

interface LoaderProps {
  maxHeight?: string | number;
}

const Loader = ({ maxHeight }: LoaderProps = {}) => {
  const loaderStyle = maxHeight ? { maxHeight } : {};

  return (
    <div data-testid="loader" className="fp_loading" style={loaderStyle}>
      <img alt="MiM" src={logo} height="68" className="h-[68px]" />
      <div className="loader mt-3 border-t-turquoise-dark"></div>
    </div>
  );
};

export default Loader;
